/* import __COLOCATED_TEMPLATE__ from './ai-agent-identity-avatar-editor.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { defer } from 'rsvp';
import { ref } from 'ember-ref-bucket';
//@ts-expect-error
import DefaultAvatars from '@intercom/pulse/lib/default-avatars';

interface AiAgentIdentityAvatar {
  avatarType: string;
  avatarData: {
    avatarShape: 'circle' | 'squircle';
    url: string;
  };
}

interface AiAgentIdentityAvatarEditorArgs {
  brandId: string;
  isDefaultBrand: boolean;
  avatar: AiAgentIdentityAvatar;
  defaultAvatarUrl: string;
  onAvatarChange: (file: File, brandId: string) => void;
  onAvatarResetToDefault: (brandId: string) => void;
}

export default class AiAgentIdentityAvatarEditor extends Component<AiAgentIdentityAvatarEditorArgs> {
  @tracked avatarType: string;
  @tracked avatarShape: 'circle' | 'squircle';
  @tracked avatarUrl: string;

  @ref('inputElement') inputElement!: HTMLInputElement;

  constructor(owner: unknown, args: AiAgentIdentityAvatarEditorArgs) {
    super(owner, args);
    this.avatarType = args.avatar.avatarType;
    this.avatarShape = args.avatar.avatarData.avatarShape;
    this.avatarUrl = args.avatar.avatarData.url;
  }

  get avatarPreview() {
    return {
      avatarType: this.avatarType,
      avatarData: {
        avatarShape: this.avatarShape,
        url: this.avatarUrl,
      },
    };
  }

  get savedAvatarIsCustom() {
    return this.avatarType === 'custom';
  }

  @action
  restoreAvatarToDefault() {
    this.avatarType = 'default';
    this.avatarUrl = this.args.isDefaultBrand
      ? DefaultAvatars.fin[128]
      : this.args.defaultAvatarUrl;
    this.args.onAvatarResetToDefault(this.args.brandId);
  }

  @action
  openFilePicker() {
    this.inputElement.click();
  }

  @action
  async setCustomAvatarFromFilePicker(fileList: FileList) {
    if (!fileList || fileList.length < 1) {
      return;
    }
    let dataUrl = await this.readFileAsDataURL(fileList[0]);
    this.avatarType = 'custom';
    this.avatarUrl = dataUrl;
    this.args.onAvatarChange(fileList[0], this.args.brandId);
    this.clearFilePicker();
  }

  private clearFilePicker() {
    if (this.inputElement) {
      this.inputElement.value = '';
    }
  }

  private readFileAsDataURL(file: File): Promise<string> {
    let deferred = defer<string>();
    let reader = new FileReader();
    reader.onload = (e) => {
      if (e.target && typeof e.target.result === 'string') {
        deferred.resolve(e.target.result);
      }
    };
    reader.readAsDataURL(file);
    return deferred.promise;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Identity::AiAgentIdentityAvatarEditor': typeof AiAgentIdentityAvatarEditor;
    'ai-agent/identity/ai-agent-identity-avatar-editor': typeof AiAgentIdentityAvatarEditor;
  }
}
